import { getAuthToken, withAuthHandoff } from '@common';
import { MPButton, MPTextArea } from '@components';
import { Form, Result } from 'antd';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import useAppname from './useAppname';
import { useSendAppErrorMessageMutation } from '@app/services';
import { toast } from 'react-toastify';

export function AppError() {
    const [form] = Form.useForm();
    const authToken = getAuthToken();
    const navigate = useNavigate();
    const [sendAppErrorMessage] = useSendAppErrorMessageMutation();

    const { maindomain, appName } = useAppname();
    const homeLink = withAuthHandoff(`${window.location.protocol}//${maindomain}`, authToken);

    const onNavigateHome = useCallback(() => {
        if (homeLink.startsWith('http')) window.location.href = homeLink;
        else navigate(homeLink);
    }, [homeLink, navigate]);

    const onSubmit = useCallback(() => {
        sendAppErrorMessage({ message: form.getFieldsValue().message, appName: appName })
            .unwrap()
            .then(() => {
                toast.success('Message sent successfully');
            })
            .catch(() => {
                toast.error('Failed to send message');
            });
    }, [form]);

    return (
        <Result
            status={500}
            title="The app is not available"
            subTitle="You can try to refresh the page or contact the administrator."
            extra={
                <div className="w-150! mx-auto!">
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onSubmit}
                    >
                        <Form.Item
                            name="message"
                            label="Contact with app owner"
                            rules={[{ required: true, message: 'Please enter your message' }]}
                        >
                            <MPTextArea
                                size="large"
                                maxLength={200}
                                showCount
                                autoSize={{ minRows: 3 }}
                                placeholder="Write your message to the app owner"
                            />
                        </Form.Item>

                        <div className="flex gap-2 justify-end">
                            <MPButton
                                type="default"
                                onClick={onNavigateHome}
                                htmlType="reset"
                            >
                                Back Home
                            </MPButton>
                            <MPButton
                                type="primary"
                                htmlType="submit"
                            >
                                Send Message
                            </MPButton>
                        </div>
                    </Form>
                </div>
            }
        />
    );
}
